import { makeStyles } from '@mui/styles';

const useButtonStyle = makeStyles(() => ({
  button: {
    height: 48,
    width: 150,
  },
}));

export default useButtonStyle;
